import { Component, OnInit, Renderer2, ElementRef} from '@angular/core';
import { Router } from '@angular/router';

// env
import { environment } from './../../../../environments/environment';

// Service
import { ApiService } from '../../../shared/service/api.service';
import { GlobalService } from '../../../shared/service/global.service';

@Component({
  selector: 'app-address-office',
  templateUrl: './address-office.component.html',
  styles: [
  ]
})
export class AddressOfficeComponent implements OnInit {
  
  dataTitle;
  dataSection = [];
  dataAddress;
  apiAsset = environment.API_ASSETS;
  dataCurAddress;

  constructor(  private renderer: Renderer2,
                private elem: ElementRef,
                private apiService: ApiService, 
                private globalService: GlobalService,
                private router: Router) {  
     this.globalService.isLoading.next(true);
  }

  ngOnInit(): void {
     // Content
    this.apiService.getDataApi('getMenuSection/address-of-offices').subscribe(response => {
      if(response.success){
        this.dataTitle = response.data;
        this.dataSection = response.data.section;
        // Meta
        this.globalService.updateMeta(
          response.data.title + ' | Prime Agri Resources',
          response.data.keyword,
          response.data.metadesc
        );
        this.globalService.isLoading.next(false);    
      }else{
        this.router.navigate(['/not-found']);
      }
    });

    // address
    this.apiService.getDataApi('getAddress?category=1').subscribe(response => {
      this.dataAddress = response.data;
      this.dataCurAddress = response.data[0];
    });
  }


  tabAddress(ev,num){
    const target = ev.currentTarget;
    const elements = this.elem.nativeElement.querySelectorAll('.address-office .ad-tab');
    let i;
    for(i=0;i<elements.length;i++) {
      this.renderer.removeClass(elements[i], 'active');
    }
    this.renderer.addClass(target, 'active');
    if(num == 0){
      this.dataCurAddress = this.dataAddress[0];
    }else if(num == 1){
      this.dataCurAddress = this.dataAddress[1];
    }
  }

}
